export default __webpack_public_path__ + "static/media/Snd_CV.5fea63d1.mp3";